import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { AffordabilityExcludedRequestsRow } from './AffordabilityExcludedRequestsRow';
import {
    TableWrapper,
    SectionHeader,
    ColumnHeader,
    TableHeaderRow,
    SectionMessage,
} from './AffordabilityExcludedRequests.style';
import { AffordabilityExcludedState } from 'src/AppState/AffordabilityExcludedState';
import { OpenapiProxyStaffAccountAffordabilityFetchAllResponse200Type as ResponseType } from 'src/api_openapi/generated/openapi_proxy_staff_account_affordability_fetch_all';

type ResponseDataInferredType = ResponseType['data'] extends Array<infer Data> ? Data : never;

const renderList = (
    affordabilityExcludedState: AffordabilityExcludedState,
    list: Array<ResponseDataInferredType>
): Array<React.ReactNode> => {
    const elements: Array<React.ReactNode> = [];

    for (const affordabilityExcludedElement of list) {
        elements.push(
            <AffordabilityExcludedRequestsRow
                key={affordabilityExcludedElement.accountId}
                affordabilityExcludedElement={affordabilityExcludedElement}
                affordabilityExcludedState={affordabilityExcludedState}
            />
        );
    }

    return elements;
};

interface PropsType {
    affordabilityExcludedState: AffordabilityExcludedState;
}

export const AffordabilityExcludedRequests = observer(
    'AffordabilityExcludedRequests',
    (props: PropsType): React.ReactElement => {
        const header = null;
        const affordabilityExcludedList = props.affordabilityExcludedState.allList;
        const totalItems = props.affordabilityExcludedState.totalItems;
        props.affordabilityExcludedState.ensureCustomerNames(affordabilityExcludedList.map((item) => item.accountId));

        if (totalItems === null || totalItems.total === 0) {
            const message = <SectionMessage>There are no items</SectionMessage>;
            return (
                <div>
                    <SectionHeader>{header}</SectionHeader>
                    {message}
                </div>
            );
        }

        return (
            <div>
                <SectionHeader>{header}</SectionHeader>
                <TableWrapper>
                    <thead>
                        <TableHeaderRow>
                            <ColumnHeader>User ID</ColumnHeader>
                            <ColumnHeader>Date</ColumnHeader>
                            <ColumnHeader>Full Name</ColumnHeader>
                            <ColumnHeader>Current Color</ColumnHeader>
                            <ColumnHeader>Previous Color</ColumnHeader>
                            <ColumnHeader>Check Trigger</ColumnHeader>
                            <ColumnHeader>Action</ColumnHeader>
                            <ColumnHeader>Reason</ColumnHeader>
                        </TableHeaderRow>
                    </thead>
                    <tbody>{renderList(props.affordabilityExcludedState, affordabilityExcludedList)}</tbody>
                </TableWrapper>
            </div>
        );
    }
);
